import Throttle from 'global-libs/under-score/throttle'
import DSMath from '../math/cool-math';
let radio = 100;
//全局比例缩放
let setGlobalFontSize = Throttle((e)=>{
    let documentElement =  document.documentElement;
    documentElement.style.fontSize = DSMath.clamp(12,24,(documentElement.clientWidth/radio))+"px";
},50);
export default class Adapter{
    static StartAdapter(refWidth,fontSize){
        radio = refWidth/fontSize;
        setGlobalFontSize();
        window.addEventListener("resize",setGlobalFontSize)
    }
}